import { styled } from '@mui/material/styles';

import CircularProgress from '@mui/material/CircularProgress';

const Loader = styled(CircularProgress)(({ theme }) => ({ display: 'block', margin: `${theme.spacing(3)} auto` }));

export default Loader;
